module.exports = __webpack_public_path__ + "img/x-ray3.3a6b0e29.jpg";